var Layer           = require("./Layer"),
    OLVectorLayerStyle   = require('OLVectorLayerStyle'),
    ol              = require("openlayers"),
    $               = require('jquery'),
    _ =             require("underscore");

var ImageLayer = Layer.extend({

    /**
     *
     * @param options
     */
    initialize: function(options){
        var that = this;
        ImageLayer.__super__.initialize.call(that, options);

        that._olLayer = new ol.layer.Vector({
            visible: options.visible,
            renderMode: 'image'
        });

        that._olLayer.set('omjsLayer', that);
        // для отслеживания актуальности запроса объектов при поступлении новго запроса
        that.lastRequestTime = 0;
        // текущий запрос объектов, отменяется при наличии нового
        that.xhrGeoJSON = false;
        that._setup(options);
    },

    /**
     *
     * @param options
     * @private
     */
    _setup: function(options){
        var that     = this;

        options || (options = {});

        if('projectLayers' in options){
            that._prjLayers = options.projectLayers;
        }

        if(that._prjLayers && that._prjLayers.getLength() > 0) {

            // source всегда один, управление идет через набор фич
            // т.к. ImageVector не имеет setSource, а при ппересоздании ImageVector карта мигает
            that._olSource = new ol.source.Vector({
                features: []
            });

            // эмуляция отмена загрузки тайлов (для проекта ImageVector прикидывается тайловым слоем)
            // с полезной функцией отмены загрузки объектов, geojson может быть большого размера
            that._olSource.cancelLoading = function () {
                if (that.xhrGeoJSON && typeof that.xhrGeoJSON.abort == 'function') {
                    that.xhrGeoJSON.abort();
                }
            };
            that._olLayer.setSource(that._olSource);

            that.setLayerStyle();
            if (that.options['activeLayers']) {
                that.setActiveLayers(that.options['activeLayers']);
            } else {
                that.fire('activeLayersChange', {
                    layerIds: that._prjLayers.pluck('map_layer_id')
                });
            }
        }

        return that;
    },

    updateLayer: function() {
        var that     = this;
        that.setActiveLayers(that.getActiveLayerCodes());
    },

    setActiveLayers: function(codes) {
        var that = this,
            layersForActivation,
            layerIds,
            objectsFields = [],
            requestTime,
            requestData = {};

        layersForActivation = that._prjLayers.filter(function(l){
            return ~codes.indexOf(l.get('code')) != 0;
        });

        that.activeLayersCodes = layersForActivation.pluck('code');

        if(that._prjLayers && that._prjLayers.getLength() > 0) {

            layerIds = that._prjLayers.getArray().filter(function (l) {
                return ~that.activeLayersCodes.indexOf(l.get('code')) != 0;
            }).map(function (l) {
                return l.get('id');
            }).sort();

            if (layerIds.length) {

                // перпезапрос списка объектов при изменении набора активных слоев
                // с актуализацией запрашиваемых полей по объектам
                objectsFields = [].concat.apply([], that._prjLayers.getArray().filter(function (l) {
                    return ~that.activeLayersCodes.indexOf(l.get('code')) != 0;
                }).map(function (l) {
                    return l.get('mapnik_style')
                        ? OLVectorLayerStyle.getObjectsFields(l.get('mapnik_style'))
                        : [];
                }));

                objectsFields = _.uniq(objectsFields).sort();
                that.lastRequestTime = requestTime = (new Date()).getTime();
                if (objectsFields.length) {
                    requestData['fields'] = objectsFields.join(',');
                }
                if (that.project.lng) {
                    requestData['lng'] = that.project.lng;
                }
                if (that.project.token) {
                    requestData['token'] = that.project.token;
                }
                that.xhrGeoJSON = $.ajax({
                    // url до geojson зашит, при добавлении новых форматов необходимо выносить в настройки
                    url: that.options.urlTemplate + that.options.mapCode + '/layers/' + layerIds.join(',') + '.geojson',
                    crossDomain: true,
                    method: "GET",
                    dataType: "json",
                    requestTime: requestTime,
                    data: requestData
                }).done(function (geoJSON) {
                    if (that.lastRequestTime > this.requestTime) {
                        return;
                    }
                    var features = (new ol.format.GeoJSON()).readFeatures(geoJSON);
                    that.getMapLayer().getSource().clear();
                    that.getMapLayer().getSource().addFeatures(features);
                });

            } else if(that.getMapLayer().getSource()) {
                that.getMapLayer().getSource().clear();
            }
            that.fire('activeLayersChange', {
                layerIds: layerIds
            });
        }
    },

    activateLayers: function(codes) {
        var that = this,
            layersForActivation,
            layerCodes,
            layerIds;

        layersForActivation = that._prjLayers.filter(function(l){
            return ~codes.indexOf(l.get('code')) != 0;
        });
        layerCodes = layersForActivation.pluck('code');
        layerCodes = _.union(that.getActiveLayerCodes(), layerCodes);

        layerIds = layersForActivation.pluck('id');
        layerIds = _.union(that.getActiveLayerIds(), layerIds);

        that.setActiveLayers(layerCodes);

        that.fire('activeLayersChange', {
            layerIds: layerIds
        });
    },

    deactivateLayers: function(codes) {
        var that = this,
            layersForActivation,
            layerCodes,
            layerIds;

        layersForActivation = that._prjLayers.filter(function(l){
            return ~codes.indexOf(l.get('code')) != 0;
        });
        layerCodes = layersForActivation.pluck('code');
        layerCodes = _.difference(that.activeLayersCodes, layerCodes);

        layerIds = layersForActivation.pluck('id');
        layerIds = _.difference(that.getActiveLayerIds(), layerIds);

        that.setActiveLayers(layerCodes);

        that.fire('activeLayersChange', {
            layerIds: layerIds
        });
    },

    getActiveLayerCodes : function() {
        var that = this,
            activeCodes;
        activeCodes = that.activeLayersCodes;

        return that._prjLayers.filter(function(l) {
            return ~activeCodes.indexOf(l.get('code')) != 0;
        }).getArray().map(function(l) {
            return l.get('code');
        });
    },

    getActiveLayerIds : function() {
        var that = this,
            activeCodes;
        activeCodes = that.activeLayersCodes;

        return that._prjLayers.filter(function(l) {
            return ~activeCodes.indexOf(l.get('code')) != 0;
        }).getArray().map(function(l) {
            return l.get('id');
        });
    },

    syncWithProject: function(without) {
        var that = this;
        var layersForActivation;
        var oldActiveLayersHash;
        var layersForActivationHash;

        if (that._prjLayers && that._prjLayers.getLength() > 0) {
            oldActiveLayersHash = [].concat(this.getActiveLayerIds()).sort(function(a, b) {
                return a - b;
            }).join(' ');

            layersForActivation = that._prjLayers.filter(function(l) {
                var res = l.get('selected');
                if (without) {
                    if (~without.indexOf(l.get('code'))) {
                        res = ~that.activeLayersCodes.indexOf(l.get('code'));
                    }
                }
                return res;
            });

            var layersForActivationIds = layersForActivation.pluck('id');

            layersForActivationHash = [].concat(layersForActivationIds).sort(function(a, b) {
                return a - b;
            }).join(' ');

            if (oldActiveLayersHash !== layersForActivationHash) {
                this.setActiveLayers(layersForActivation.pluck('code'));
            }

            return {
                changes: oldActiveLayersHash !== layersForActivationHash,
                oldLayers: oldActiveLayersHash !== "" ? oldActiveLayersHash.split(' ') : [],
                newLayers: layersForActivationHash !== "" ? layersForActivationHash.split(' ') : []
            };
        }
    }
});

module.exports = ImageLayer;



//////////////////
// WEBPACK FOOTER
// ./src/View/ImageLayer.js
// module id = 47
// module chunks = 0